export default __webpack_public_path__ + "b765fa0fdd4f41e31857c644533b5561.svg";